import { render, staticRenderFns } from "./AdsType5.vue?vue&type=template&id=70a715ef&scoped=true&"
import script from "./AdsType5.vue?vue&type=script&lang=js&"
export * from "./AdsType5.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AdsType5.vue?vue&type=style&index=0&id=70a715ef&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "70a715ef",
  null
  ,true
)

export default component.exports